import { computed, watch } from 'vue'
import { getBusinessPath } from '@/utils/localeRoute.js'
import { useZendeskMessenger } from './useZendeskMessenger.js'
import { loadZendeskSnippet } from './loadZendeskSnippet.js'

const hiddenCustomerServicePaths = ['/trade', '/futures', '/coinStockFutures', '/coinStockTrade', '/ru', '/user/register']

const getCssColor = (name, fallback) => {
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim()
  return value || fallback
}

const getZendeskTheme = () => ({
  theme: {
    // 主品牌色，主要影响 launcher 按钮、强调按钮和主操作色
    primary: getCssColor('--primary', '#2649EF'),
    // 主品牌色上的前景色，通常是按钮文字/图标颜色
    onPrimary: getCssColor('--while', '#FFFFFF'),
    // 普通消息气泡背景色
    // message: getCssColor('--f4', '#F4F4F4'),
    // 普通消息气泡文字色
    // onMessage: getCssColor('--theme-text', '#333333'),
    // 商家/客服消息气泡背景色
    // businessMessage: getCssColor('--whiteAnd51A', '#FFFFFF'),
    // 商家/客服消息气泡文字色
    // onBusinessMessage: getCssColor('--theme-text', '#333333'),
    // 可点击动作颜色，例如链接、按钮等强调操作
    // action: getCssColor('--primary', '#2649EF'),
    // 动作按钮/链接上的前景色
    // onAction: getCssColor('--while', '#FFFFFF'),
    // 整个聊天面板的大背景色
    // background: getCssColor('--while', '#FFFFFF'),
    // 聊天面板大背景上的默认文字色
    // onBackground: getCssColor('--theme-text', '#333333'),
  },
})

export const useZendeskLauncher = () => {
  const route = useRoute()
  const userStore = useUserStore()
  const configStore = useConfigStore()
  const { showMessenger, hideMessenger, setCustomization, setZIndex } = useZendeskMessenger()
  let syncTaskId = 0

  const businessPath = computed(() => getBusinessPath(route.path))
  const shouldShowCustomerService = computed(() => !hiddenCustomerServicePaths.includes(businessPath.value) && !!userStore.token)

  const syncZendeskTheme = () => {
    setCustomization(getZendeskTheme())
  }

  watch(
    () => configStore.theme,
    () => {
      syncZendeskTheme()
    },
    {
      immediate: true,
    }
  )

  watch(
    shouldShowCustomerService,
    async (visible) => {
      const currentTaskId = ++syncTaskId

      if (!visible) {
        hideMessenger()
        return
      }

      try {
        await loadZendeskSnippet()
      } catch (error) {
        console.error('[Zendesk] snippet load failed', error)
        return
      }

      if (currentTaskId !== syncTaskId || !shouldShowCustomerService.value) {
        return
      }

      syncZendeskTheme()
      setZIndex(1000)
      showMessenger()
    },
    {
      immediate: true,
    }
  )
}
